<template>
  <SplashPage v-if="showSplash" /> <!-- Splash Page -->
  <!-- Conteúdo principal da aplicação -->
  <div v-else class="container-mestre invisible-scrollbar">
    <Navbar v-if="showNav" :rota="currentRoute" />
    <RouterView />
  </div>
</template>
<script>
import { ref, computed, onMounted, getCurrentInstance } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { getAuth } from 'firebase/auth'; // Importa a autenticação do Firebase
import Navbar from '@/components/NavBar.vue';
import SplashPage from '@/components/SplashPage.vue';
import FirebaseHelper from "@/service/FirebaseHelper";
import { getAppEnvironment } from '@/utils/env';

export default {
  components: {
    Navbar,
    SplashPage,
  },
  setup() {
    const router = useRouter();
    const currentRoute = ref(router.currentRoute.value.path);
    const store = useStore();
    const showNav = computed(() => currentRoute.value !== '/login' && currentRoute.value !== '/alertacustom' && currentRoute.value !== '/instalacao');
    const producao = ref(false);
    const showSplash = ref(true);
    const user = ref(null); // Para armazenar o usuário autenticado  
    const projeto = store.getters.projetoFirebase;
    const firebaseHelper = new FirebaseHelper()
    const auth = getAuth(); // Inicializa o Firebase Auth

    const hideSplash = () => {
      setTimeout(() => {
        showSplash.value = false;
      }, 4000);
    };
    if (projeto === 'portaloabprevpr') {
      producao.value = true
    }
    onMounted(async () => {
      hideSplash();
      const env = getAppEnvironment();
      console.log('Ambiente detectado:', env);
      if (env === 'cordova') {
        auth.onAuthStateChanged((userData) => {
          user.value = userData
          if (!user.value) {
            router.push({
              path: '/login',
            })
            return;
          } else {

            firebaseHelper.getLoginUsuario(auth.currentUser.uid).then((tipo_login) => {

              console.log('tipo_login', tipo_login)
              
              if (tipo_login) {
                store.commit('setLogin', tipo_login);
                store.commit('setChave', tipo_login.chave_principal);
                store.commit('setNovaChave', '');
                store.commit('setCpf', tipo_login.cpfPrincipal);
                if (tipo_login.chave_principal && tipo_login.chave_principal.includes("RP-")) {
                  store.commit('setIsRP', true);
                  console.log('auth.currentUser >>>>>>>>>>>>>', auth.currentUser)
                  store.commit('setEmail', auth.currentUser.email);
                  console.log('tipo_login:', tipo_login);
                  console.log('chave_principal:', tipo_login.chave_principal);
                  store.commit('setChavePrincipal', tipo_login.chave_principal);
                  console.log('Valor no store:', store.state.chavePrincipal.chavePrincipal);
                  // router.push({
                  //   path: "/trocaparticipacao",
                  //   query: { uid: auth.currentUser.uid },
                  // });
                  return;
                } else if (tipo_login.chave_principal) {
                  store.commit('setIsRP', false);
                  // router.push({
                  //   path: "/", 
                  //   query: {chave: tipo_login.chave_principal }
                  // });
                  return;
                }
              } else {
                router.push({ path: "/errologin" });
                return;
              }
            })
          }
        });
      } else if (env === 'web' || env === 'pwa') {
        // Para ambiente web, você pode definir o usuário como null ou buscar de outra forma
        const instance = getCurrentInstance();
        window.addEventListener('beforeinstallprompt', (e) => {
          e.preventDefault();
          instance.appContext.config.globalProperties.install = e;
        });

        // Coloque a função fora do callback, dentro do setup
        const isPWAInstalled = () => {
          const isIOSStandalone = window.navigator.standalone === true;
          const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
          const isWindowControlsOverlay = window.matchMedia('(display-mode: window-controls-overlay)').matches;
          return isIOSStandalone || isStandalone || isWindowControlsOverlay;
        };

        // Função para verificar se o PWA está instalado mas não está sendo usado
        const checkPWAUsage = () => {
          const pwaInstalled = localStorage.getItem('pwaInstalled') === 'true';
          const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
          const isIOSStandalone = window.navigator.standalone === true;

          // Se o PWA está instalado mas não está sendo usado em modo standalone
          if (pwaInstalled && !isStandalone && !isIOSStandalone) {
            // Verifica se é Windows ou macOS
            if (navegador === 'Windows' || navegador === 'macOS') {
              showSplash.value = false;
              router.push({ path: '/instalacao' });
              return true;
            }
          }
          return false;
        };

        // Função para verificar e armazenar o estado de instalação do PWA
        const checkAndStorePWAInstallation = () => {
          const isInstalled = isPWAInstalled();
          localStorage.setItem('pwaInstalled', isInstalled);
          localStorage.setItem('pwaInstallDate', new Date().toISOString());
          return isInstalled;
        };

        // Função para verificar se deve mostrar o prompt de instalação
        const shouldShowInstallPrompt = () => {
          const lastPromptDate = localStorage.getItem('pwaLastPromptDate');
          if (!lastPromptDate) return true;

          const lastPrompt = new Date(lastPromptDate);
          const now = new Date();
          const daysSinceLastPrompt = (now - lastPrompt) / (1000 * 60 * 60 * 24);

          // Mostra o prompt novamente após 7 dias
          return daysSinceLastPrompt >= 7;
        };

        // Função para atualizar a data do último prompt
        const updateLastPromptDate = () => {
          localStorage.setItem('pwaLastPromptDate', new Date().toISOString());
        };


        const pwaInstalled = localStorage.getItem('pwaInstalled');

        // Primeiro verifica se o PWA está instalado mas não está sendo usado
        if (checkPWAUsage()) {
          return;
        }

        if (pwaInstalled === null) {
          // Primeira visita - verifica e armazena o estado
          if (!checkAndStorePWAInstallation()) {
            showSplash.value = false;
            if (shouldShowInstallPrompt()) {
              router.push({ path: '/instalacao' });
              updateLastPromptDate();
            }
            return;
          }
        } else if (pwaInstalled === 'false') {
          // Já visitou antes e não está instalado
          if (!isPWAInstalled()) {
            showSplash.value = false;
            if (shouldShowInstallPrompt()) {
              router.push({ path: '/instalacao' });
              updateLastPromptDate();
            }
            return;
          } else {
            // PWA foi instalado desde a última visita
            localStorage.setItem('pwaInstalled', 'true');
            localStorage.setItem('pwaInstallDate', new Date().toISOString());
          }
        }

        // Adiciona listener para o evento beforeinstallprompt
        window.addEventListener('beforeinstallprompt', (e) => {
          e.preventDefault();
          const instance = getCurrentInstance();
          instance.appContext.config.globalProperties.install = e;
          instance.appContext.config.globalProperties.canInstall = true;
        });

        auth.onAuthStateChanged((userData) => {
          user.value = userData
          if (!user.value) {
            router.push({
              path: '/login',
            })
            return;
          } else {

            firebaseHelper.getLoginUsuario(auth.currentUser.uid).then((tipo_login) => {

              console.log('tipo_login', tipo_login)
              
              if (tipo_login) {
                store.commit('setLogin', tipo_login);
                store.commit('setChave', tipo_login.chave_principal);
                store.commit('setNovaChave', '');
                store.commit('setCpf', tipo_login.cpfPrincipal);
                store.commit('setChavePrincipal', tipo_login.chave_principal);
                  console.log('Valor no store:', store.state.chavePrincipal);
                if (tipo_login.chave_principal && tipo_login.chave_principal.includes("RP-")) {
                  store.commit('setIsRP', true);
                  console.log('auth.currentUser >>>>>>>>>>>>>', auth.currentUser)
                  store.commit('setEmail', auth.currentUser.email);
                  console.log('tipo_login:', tipo_login);
                  console.log('chave_principal:', tipo_login.chave_principal);
                  store.commit('setChavePrincipal', tipo_login.chave_principal);
                  console.log('Valor no store:', store.state.chavePrincipal);
                  // router.push({
                  //   path: "/trocaparticipacao",
                  //   query: { uid: auth.currentUser.uid },
                  // });
                  return;
                } else if (tipo_login.chave_principal) {
                  store.commit('setIsRP', false);
                  // router.push({
                  //   path: "/", 
                  //   query: {chave: tipo_login.chave_principal }
                  // });
                  return;
                }
              } else {
                router.push({ path: "/errologin" });
                return;
              }
            })
          }
        });

      }
    });
    return {
      store,
      showNav,
      currentRoute,
      projeto,
      producao,
      showSplash,
      user, // Retorne o usuário para uso no template, se necessário
    };
  }
};
</script>

<style scoped lang="scss">
/* Seus estilos atuais */
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.container {
  max-width: 720px;
}

.projeto {
  height: 15px;
  width: 100%;
  background-color: #db130c;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  font-size: 12px;
  color: aliceblue;
}
</style>
